import { storageName } from '../utils/storage';
import Dexie from 'dexie';
import { indexedDbOperation } from '../utils/indexedDbOperation';
import { assertDraftOwnerActive, isDeletedOwner } from '../accountDeletion/ownerState';

// Deliberately separate from NewsDatabase: refreshing the feed must never
// remove private local recordings. Blob URLs are only made while rendering.
const database = new Dexie(storageName('WiwRecordingDrafts'));
database.version(1).stores({ drafts: 'key, userId, updatedAt' });
export const mediaDraftKey = (userId, storyId, draftId) => `${userId}:${storyId}:${draftId}`;
export const readMediaDraft = key => indexedDbOperation(database, 'r', ['drafts'], async () => {
  const row = await database.drafts.get(key);
  return row && !isDeletedOwner(row.userId) ? row : undefined;
});
export const writeMediaDraft = draft => indexedDbOperation(database, 'rw', ['drafts'],
  () => { assertDraftOwnerActive(draft.userId); return database.drafts.put({ ...draft, updatedAt: Date.now() }); });
export const deleteMediaDraft = key => indexedDbOperation(database, 'rw', ['drafts'], () => database.drafts.delete(key));
export const deleteOwnerMediaDrafts = userId => indexedDbOperation(database, 'rw', ['drafts'],
  () => database.drafts.where('userId').equals(Number(userId)).delete());
